/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgEditOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      d="M14.218 4.417H5.3a.5.5 0 00-.5.5v14.198a.5.5 0 00.5.5h12.833a.5.5 0 00.5-.5V15.2h1.5v3.915l-.01.204a2 2 0 01-1.786 1.785l-.204.01H5.3l-.204-.01a2 2 0 01-1.785-1.785l-.011-.204V4.917a2 2 0 012-2h8.918v1.5zm4.448-.091a1 1 0 011.427 0l1.046 1.064a1 1 0 01-.001 1.403l-9.614 9.743a1.998 1.998 0 01-.74.475l-2.477.898a.4.4 0 01-.518-.498l.813-2.54a2 2 0 01.478-.792l9.586-9.753z"
      fill="currentColor"
    />
  </svg>
)
const Memo = memo(SvgEditOutlined)
export default Memo
